import React from "react";
import LightingIcon from "../../../icons/LightingIcon";
import PlusIcon from "../../../icons/PlusIcon";
import styles from "./AddPostButton.module.scss";
import { Link } from "react-router-dom";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  mobileButton: {
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  desktopButton: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

const AddPostButton = (props) => {
  const { title, href, onClick, ...rest } = props;
  const classes = useStyles();

  const buttonContent = (
    <React.Fragment>
      <div className={classes.desktopButton}>
        <PlusIcon className={styles.plusIcon} />
        <span className={styles.label}>{title}</span>
        <div className={styles.lightingIconWrap}>
          <LightingIcon className={styles.lightingIcon} />
        </div>
      </div>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      {onClick ? (
        <span className={styles.root} onClick={onClick} {...rest}>
          {buttonContent}
        </span>
      ) : (
        <Link className={styles.root} to={href} {...rest}>
          {buttonContent}
        </Link>
      )}
    </React.Fragment>
  );
};

AddPostButton.defaultProps = {
  onClick: null,
};

export default AddPostButton;
